// Role IDs mirror api/src/AveOrga.Domain/Enums/Role.cs
export const ROLE_ADMIN = 4;
export const ROLE_ORGANIZER = 3;

export function isAdmin() {
  return Number(localStorage.getItem('statusId')) === ROLE_ADMIN;
}

export function isOrgaOrAdmin() {
  return Number(localStorage.getItem('statusId')) >= ROLE_ORGANIZER;
}

export function clearAuthStorage() {
  localStorage.setItem('playerId', 0);
  localStorage.setItem('statusId', 0);
}
